// API Configuration 
export const API_BASE_URL = 'https://factory-monitoring-dashboard.onrender.com'; 
 
// Optional: Add other config variables here 
export const REFRESH_INTERVAL = 30000; // 30 seconds 
